import { render, staticRenderFns } from "./ContentContainer.vue?vue&type=template&id=ca3ab0aa&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"
import style0 from "./ContentContainer.vue?vue&type=style&index=0&id=ca3ab0aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ab0aa",
  null
  
)

export default component.exports